import { Icon, IconProps } from './Icon';

export type FolderProps = IconProps;

export const Folder = (props: FolderProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="m8.667 4.667-.744-1.488c-.214-.428-.321-.642-.48-.798a1.333 1.333 0 0 0-.499-.308C6.733 2 6.494 2 6.014 2H3.468c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.659-.146 1.405v.534m0 0h10.134c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108V10.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H4.533c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V4.667Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
